import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["data-order-id"];
const _hoisted_2 = ["title"];
const _hoisted_3 = { class: "text-center" };
const _hoisted_4 = { class: "text-center" };
const _hoisted_5 = { class: "text-left" };
const _hoisted_6 = { class: "text-left" };
const _hoisted_7 = { class: "text-center" };
const _hoisted_8 = { class: "text-center" };
const _hoisted_9 = { class: "text-left" };
const _hoisted_10 = { class: "text-center" };
const _hoisted_11 = { class: "text-center" };
const _hoisted_12 = { class: "text-center" };
const _hoisted_13 = { class: "text-center" };
const _hoisted_14 = { class: "text-center" };
const _hoisted_15 = { class: "text-center" };
const _hoisted_16 = { class: "text-center" };
const _hoisted_17 = { class: "text-center" };
const _hoisted_18 = { class: "text-center" };
const _hoisted_19 = { class: "text-center" };
const _hoisted_20 = { class: "text-right" };
const _hoisted_21 = { class: "text-right" };
const _hoisted_22 = { class: "text-right" };
const _hoisted_23 = { class: "text-right" };
const _hoisted_24 = { class: "text-right" };
const _hoisted_25 = { class: "text-right" };
const _hoisted_26 = { class: "text-right" };
const _hoisted_27 = { class: "text-center" };
const _hoisted_28 = { class: "text-right" };
const _hoisted_29 = { class: "text-right" };
const _hoisted_30 = { class: "text-right" };
const _hoisted_31 = { class: "text-right" };
const _hoisted_32 = { class: "text-center" };
const _hoisted_33 = { class: "text-center" };
const _hoisted_34 = { class: "text-center" };
const _hoisted_35 = { class: "text-center" };
const _hoisted_36 = { class: "text-center" };
const _hoisted_37 = { class: "text-center" };
const _hoisted_38 = { class: "text-center" };
const _hoisted_39 = { class: "cy-order-id text-center" };
const _hoisted_40 = { class: "text-right" };
import { computed, onMounted, ref, toRefs, } from 'vue';
import { orderType, payTypeCode, } from '@/constants';
import { i18n } from '@/locales';
import { noSpaceCurrency, formatDate, } from '@/utils';
import vuexStore from '@/vuex-store';
import PayType from '@/components/PayType.vue';
import Chip, { brgChipColorMapper } from '@/components/Common/Chip.vue';
import OrderStatusChip from '@/components/Common/OrderStatusChip.vue';
import { orderStatusGroup } from '@/constants/listControl';
import { listControlActionType } from '@/vuex-store/list-control/actions';
import { listControlGetterType } from '@/vuex-store/list-control/getters';
import dateFormatType from '@/constants/dateFormatType';
import { pStore } from '@/pinia';
// 카드 시간 업데이트 간격 10초
const orderTimeUpdateInterval = 10 * 1000;
const lc = 'views.map_control.order_wrapper.order_item.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderItem',
    props: {
        orderItem: {},
        openOrderModal: { type: Function },
        openWorkerModal: { type: Function }
    },
    setup(__props) {
        const props = __props;
        const { orderItem, openOrderModal, openWorkerModal, } = toRefs(props);
        const firstTd = ref(undefined);
        const isShowTooltip = ref(false);
        /**
         * 우클릭 이벤트
         */
        const handleClickRight = (event) => {
            const tr = event.target
                .closest('tr');
            const { orderId } = tr.dataset;
            const selection = window.getSelection()?.toString();
            // 드래그로 선택한게 있다면 우클릭 작동 x
            if (selection) {
                return;
            }
            event.preventDefault();
            vuexStore.dispatch(listControlActionType.toggleContextMenu, {
                isOpen: true,
                event,
                orderId,
            });
        };
        const pWorkerAllocate = pStore.piniaWorkerAllocate;
        const pLocationControl = pStore.piniaLocationControl;
        /**
         * 주문 클릭
         */
        const handleClickOrder = async () => {
            const { orderId } = orderItem.value;
            // 기존 주문 재클릭
            if (await vuexStore.getters[listControlGetterType.includesSelectedItemList](orderId)) {
                vuexStore.dispatch(listControlActionType.clearSelectedOrderItem, orderItem.value.orderId);
                window.popupMapControl?.selectOrder(orderId);
                return;
            }
            // 추가 선택 가능 여부 판단
            if (vuexStore.getters[listControlGetterType.isMaxSelectedItem]) {
                return;
            }
            vuexStore.dispatch(listControlActionType.addSelectedOrderItem, orderItem.value);
            window.popupMapControl?.selectOrder(orderId);
            // 테스트를 위한 임시 작업
            pWorkerAllocate.orderId = orderId;
            pLocationControl.orderId = orderId;
        };
        /**
         * 주문 상세 더블 클릭
         */
        const handleDblClickOrder = () => {
            const { orderId } = orderItem.value;
            openOrderModal.value(orderId);
        };
        /**
         * 라이더 이름 클릭 핸들러
         */
        const handleClickWorkerName = () => {
            const { allocatedWorkerCode } = orderItem.value;
            openWorkerModal.value(allocatedWorkerCode);
        };
        // B2B 혹은 공유
        const isShare = computed(() => {
            if (orderItem.value.orderType === orderType.B2B) {
                return 'is-b2b';
            }
            if (orderItem.value.orderType === orderType.SHARED) {
                return 'is-share';
            }
            return 'is-own';
        });
        /** 주문 상태별 색상 */
        const trCssClass = computed(() => {
            const { statusCode } = orderItem.value;
            // TODO 타입 수정 필요
            const s = orderStatusGroup[statusCode];
            let color = '';
            switch (s) {
                case 'ACCEPTED':
                    color = 'accepted';
                    break;
                case 'ALLOCATED':
                    color = 'allocated';
                    break;
                case 'PICKUP':
                    color = 'pickup';
                    break;
                case 'DROP_FINISHED':
                    color = 'drop-finished';
                    break;
                case 'CANCELED':
                    color = 'canceled';
                    break;
                default:
                    return '';
            }
            return {
                [color]: true,
            };
        });
        /** 도착지 주소 */
        const orderDropAddress = computed(() => orderItem.value.getDropFullAddress());
        /** 출발지 주소 */
        const orderPickupAddress = computed(() => orderItem.value.getPickupFullAddress());
        const intervalDisplayTime = ref({
            text: '',
            color: '',
            isDelayedOrder: undefined,
        });
        const intervalTimer = ref(-1);
        /**
         * 시간 업데이트
         */
        const updateIntervalDisplayTime = () => {
            intervalDisplayTime.value = orderItem.value.displayTime();
        };
        /**
         * 남은 시간 계산
         */
        const initInterval = () => {
            updateIntervalDisplayTime();
            intervalTimer.value = setInterval(() => {
                updateIntervalDisplayTime();
            }, orderTimeUpdateInterval);
        };
        const isAddressBaseOrderChip = computed(() => {
            if (!orderItem.value.isAddressBaseOrder()) {
                return false;
            }
            return true;
        });
        const agencyOrderColor = computed(() => (orderItem.value.orderAgencyOptions?.allocateLimit > 1
            ? brgChipColorMapper.blue
            : brgChipColorMapper.orange));
        const agencyOrderText = computed(() => (orderItem.value.orderAgencyOptions?.allocateLimit > 1 ? i18n.t(`${lc}bundle`) : i18n.t(`${lc}unit`)));
        const isIncludeAlcohol = computed(() => orderItem.value.orderAgencyOptions?.includeAlcohol);
        const isUntact = computed(() => orderItem.value.payTypeCode === payTypeCode.UNTACT.code);
        const cssClassHighlight = computed(() => vuexStore.getters[listControlGetterType.includesSelectedItemList](orderItem.value.orderId));
        const tooltipXY = ref({
            top: '0px',
            left: '0px',
        });
        /**
         * 주문 타입 셀 마우스엔터 이벤트 핸들러
         * @param e
         */
        // eslint-disable-next-line no-return-assign
        const handleMouseEnterTd = (event) => {
            const el = event.target;
            const rect = el.getBoundingClientRect();
            const t = rect.top;
            const l = rect.left + rect.width + 5;
            // 여기서 주고 컴포지션은 받아 쓰게 업데이트 하게끔...
            isShowTooltip.value = true;
            tooltipXY.value = {
                top: `${t}px`,
                left: `${l}px`,
            };
        };
        // eslint-disable-next-line no-return-assign
        const handleMouseLeaveTd = () => isShowTooltip.value = false;
        onMounted(() => {
            initInterval();
        });
        return (_ctx, _cache) => {
            const _component_v_tooltip = _resolveComponent("v-tooltip");
            const _directive_tr_highlight = _resolveDirective("tr-highlight");
            return _withDirectives((_openBlock(), _createElementBlock("tr", {
                "data-order-id": _unref(orderItem).orderId,
                "data-cy": "order-item",
                class: _normalizeClass(["cy-order-item order-item", trCssClass.value]),
                onClick: handleClickOrder,
                onDblclick: handleDblClickOrder,
                onContextmenu: handleClickRight
            }, [
                _createCommentVNode(" 공유 상태 "),
                _createElementVNode("td", {
                    ref_key: "firstTd",
                    ref: firstTd,
                    class: _normalizeClass(isShare.value),
                    onMouseenter: handleMouseEnterTd,
                    onMouseleave: handleMouseLeaveTd
                }, [
                    _createVNode(_component_v_tooltip, {
                        modelValue: isShowTooltip.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isShowTooltip).value = $event)),
                        style: _normalizeStyle(tooltipXY.value),
                        transition: false
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(orderItem).orderTypeForClient), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "style"])
                ], 34 /* CLASS, NEED_HYDRATION */),
                _createCommentVNode(" 상태 "),
                _createElementVNode("td", {
                    class: "text-center",
                    title: `${_unref(orderItem).orderId} / ${_unref(orderItem).todayNumber}`
                }, [
                    _createVNode(OrderStatusChip, {
                        "status-code": _unref(orderItem).statusCode
                    }, null, 8 /* PROPS */, ["status-code"])
                ], 8 /* PROPS */, _hoisted_2),
                _createCommentVNode(" 주의사항 "),
                _createElementVNode("td", _hoisted_3, [
                    _createCommentVNode(" 주소기반배달관련 단건, 묶음 여부 "),
                    (isAddressBaseOrderChip.value)
                        ? (_openBlock(), _createBlock(Chip, {
                            key: 0,
                            "brg-chip-color": agencyOrderColor.value,
                            text: agencyOrderText.value,
                            class: "mx-05"
                        }, null, 8 /* PROPS */, ["brg-chip-color", "text"]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 주류 여부 "),
                    (isIncludeAlcohol.value)
                        ? (_openBlock(), _createBlock(Chip, {
                            key: 1,
                            "brg-chip-color": "red",
                            text: "19",
                            class: "mx-05"
                        }))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 비대면 칩 "),
                    (isUntact.value)
                        ? (_openBlock(), _createBlock(Chip, {
                            key: 2,
                            "brg-chip-color": "blue",
                            text: _ctx.$t('common.untact_short'),
                            class: "mx-05"
                        }, null, 8 /* PROPS */, ["text"]))
                        : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" 당일순번 "),
                _createElementVNode("td", _hoisted_4, _toDisplayString(_unref(orderItem).todayNumber), 1 /* TEXT */),
                _createCommentVNode(" 발주허브 "),
                _createElementVNode("td", _hoisted_5, _toDisplayString(_unref(orderItem).hubName), 1 /* TEXT */),
                _createCommentVNode(" 발주상점 "),
                _createElementVNode("td", _hoisted_6, _toDisplayString(_unref(orderItem).storeName), 1 /* TEXT */),
                _createCommentVNode(" 상점 전화번호 "),
                _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(orderItem).storePhone), 1 /* TEXT */),
                _createCommentVNode(" 고객번호1 "),
                _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(orderItem).receiverPhone), 1 /* TEXT */),
                _createCommentVNode(" 담당 라이더 "),
                _createElementVNode("td", _hoisted_9, [
                    _createElementVNode("span", {
                        class: "hv-underline",
                        onClick: _withModifiers(handleClickWorkerName, ["stop"])
                    }, _toDisplayString(_unref(orderItem).allocatedWorkerName), 1 /* TEXT */),
                    _createCommentVNode(" {{ orderItem.orderId }}\n      /\n      {{ orderItem.todayNumber }} ")
                ]),
                _createCommentVNode(" 라이더 전화번호 "),
                _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(orderItem).allocatedWorkerPhone), 1 /* TEXT */),
                _createCommentVNode(" 배차라이더총판 "),
                _createElementVNode("td", _hoisted_11, [
                    _createCommentVNode("\n    배차라이더총판이 null이네?\n    {{ orderItem.allocatedDistributorName }}\n     "),
                    _createTextVNode(" " + _toDisplayString(_unref(orderItem).allocatedDistributorId), 1 /* TEXT */)
                ]),
                _createCommentVNode(" 배차라이더허브 "),
                _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(orderItem).allocatedHubName), 1 /* TEXT */),
                _createCommentVNode(" 출발지 주소 "),
                _createElementVNode("td", null, _toDisplayString(orderPickupAddress.value), 1 /* TEXT */),
                _createCommentVNode(" 출발지 메모 "),
                _createElementVNode("td", null, _toDisplayString(_unref(orderItem).pickupAddressMemo), 1 /* TEXT */),
                _createCommentVNode(" 도착지 주소 "),
                _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(orderDropAddress.value) + " ", 1 /* TEXT */),
                    _createCommentVNode(" {{ orderItem.statusCode }} ")
                ]),
                _createCommentVNode(" 특이사항. memo가 특이사항임 (메모 종류가 많음. 헷갈리기 쉬움)"),
                _createElementVNode("td", null, [
                    _createCommentVNode(" {{ orderItem.caution }} "),
                    _createTextVNode(" " + _toDisplayString(_unref(orderItem).memo), 1 /* TEXT */)
                ]),
                _createCommentVNode(" 주문상품 "),
                _cache[1] || (_cache[1] = _createElementVNode("td", { class: "text-center" }, [
                    _createCommentVNode(" 뭘까. ")
                ], -1 /* CACHED */)),
                _createCommentVNode(" 상품상태 "),
                _cache[2] || (_cache[2] = _createElementVNode("td", { class: "text-center" }, [
                    _createCommentVNode(" 뭘까. ")
                ], -1 /* CACHED */)),
                _createCommentVNode(" 준비상태 "),
                _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(orderItem).preparedState), 1 /* TEXT */),
                _createCommentVNode(" 경과시간 "),
                _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("span", {
                        class: _normalizeClass(intervalDisplayTime.value.color)
                    }, _toDisplayString(intervalDisplayTime.value.text), 3 /* TEXT, CLASS */)
                ]),
                _createCommentVNode(" 접수시간 "),
                _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(formatDate)(_unref(orderItem).orderedAt, _unref(dateFormatType).SHORT_TIME)), 1 /* TEXT */),
                _createCommentVNode(" 배차시간 "),
                _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(formatDate)(_unref(orderItem).allocatedAt, _unref(dateFormatType).SHORT_TIME)), 1 /* TEXT */),
                _createCommentVNode(" 픽업예상시간 "),
                _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(formatDate)(_unref(orderItem).pickupExpectedAt, _unref(dateFormatType).SHORT_TIME)), 1 /* TEXT */),
                _createCommentVNode(" 픽업시간 "),
                _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(formatDate)(_unref(orderItem).pickedUpAt, _unref(dateFormatType).SHORT_TIME)), 1 /* TEXT */),
                _createCommentVNode(" 완료시간 "),
                _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(formatDate)(_unref(orderItem).finishedAt, _unref(dateFormatType).SHORT_TIME)), 1 /* TEXT */),
                _createCommentVNode(" 예약시간 "),
                _cache[3] || (_cache[3] = _createElementVNode("td", { class: "text-center" }, [
                    _createCommentVNode(" 뭘까. ")
                ], -1 /* CACHED */)),
                _createCommentVNode(" 상품 금액 "),
                _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(noSpaceCurrency)(_unref(orderItem).orderAmount)), 1 /* TEXT */),
                _createCommentVNode(" 패널티누적액 "),
                _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(noSpaceCurrency)(_unref(orderItem).allocatedCancelPenaltyAmount)), 1 /* TEXT */),
                _createCommentVNode(" 배달대행료 "),
                _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(noSpaceCurrency)(_unref(orderItem).deliveryAmount)), 1 /* TEXT */),
                _createCommentVNode(" 라이더지원금 "),
                _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(noSpaceCurrency)(_unref(orderItem).workerSupportAmount)), 1 /* TEXT */),
                _createCommentVNode(" 프로모션지원금 "),
                _createElementVNode("td", _hoisted_24, _toDisplayString(_unref(noSpaceCurrency)(_unref(orderItem).promotionSupportAmount)), 1 /* TEXT */),
                _createCommentVNode(" 상품할증료 "),
                _createElementVNode("td", _hoisted_25, _toDisplayString(_unref(noSpaceCurrency)(_unref(orderItem).goodsPriceSurcharge)), 1 /* TEXT */),
                _createCommentVNode(" 대행료합계 "),
                _createElementVNode("td", _hoisted_26, _toDisplayString(_unref(noSpaceCurrency)(_unref(orderItem).purchaseDeliveryCharge)), 1 /* TEXT */),
                _createCommentVNode(" 결제방법 "),
                _createElementVNode("td", _hoisted_27, [
                    _createVNode(PayType, {
                        inline: "",
                        "pay-types": _unref(orderItem).payMethod
                    }, null, 8 /* PROPS */, ["pay-types"]),
                    _createCommentVNode(" {{ orderItem.deliveryAmount }} ")
                ]),
                _createCommentVNode(" 현금 "),
                _createElementVNode("td", _hoisted_28, _toDisplayString(_unref(noSpaceCurrency)(_unref(orderItem).payCashAmount)), 1 /* TEXT */),
                _createCommentVNode(" 카드 "),
                _createElementVNode("td", _hoisted_29, _toDisplayString(_unref(noSpaceCurrency)(_unref(orderItem).payCardAmount)), 1 /* TEXT */),
                _createCommentVNode(" 선결제 "),
                _createElementVNode("td", _hoisted_30, _toDisplayString(_unref(noSpaceCurrency)(_unref(orderItem).prePayAmount)), 1 /* TEXT */),
                _createCommentVNode(" 비과세(보증금) "),
                _createElementVNode("td", _hoisted_31, _toDisplayString(_unref(noSpaceCurrency)(_unref(orderItem).taxFreePayAmount)), 1 /* TEXT */),
                _createCommentVNode(" 카드승인 "),
                _cache[4] || (_cache[4] = _createElementVNode("td", { class: "text-center" }, [
                    _createCommentVNode(" 뭘까. ")
                ], -1 /* CACHED */)),
                _createCommentVNode(" 카드승인번호 "),
                _createElementVNode("td", _hoisted_32, _toDisplayString(_unref(orderItem).cardApproveNumber), 1 /* TEXT */),
                _createCommentVNode(" 카드사 "),
                _createElementVNode("td", _hoisted_33, _toDisplayString(_unref(orderItem).cardName), 1 /* TEXT */),
                _createCommentVNode(" 할부개월 "),
                _createElementVNode("td", _hoisted_34, _toDisplayString(_unref(orderItem).month), 1 /* TEXT */),
                _createCommentVNode(" 주소기반배달정보 "),
                _createElementVNode("td", _hoisted_35, _toDisplayString(_unref(orderItem).orderAgencyIdForClient()), 1 /* TEXT */),
                _createCommentVNode(" 주문제휴사배달아이디 "),
                _cache[5] || (_cache[5] = _createElementVNode("td", { class: "text-center" }, [
                    _createCommentVNode(" 뭘까. ")
                ], -1 /* CACHED */)),
                _createCommentVNode(" 주류 "),
                _createCommentVNode(" <td\n      class=\"text-center\"\n    >\n      주의사항에 있음\n    </td> "),
                _createCommentVNode(" 취소메모 "),
                _createElementVNode("td", _hoisted_36, _toDisplayString(_unref(orderItem).cancelMemo), 1 /* TEXT */),
                _createCommentVNode(" 배차취소 패널티 횟수 "),
                _createElementVNode("td", _hoisted_37, _toDisplayString(_unref(orderItem).allocatedCancelPenaltyCount), 1 /* TEXT */),
                _createCommentVNode(" 라이더에게 지불 방식 "),
                _createElementVNode("td", _hoisted_38, _toDisplayString(_unref(orderItem).deliveryPayTypeForClient), 1 /* TEXT */),
                _createCommentVNode(" 상담원 "),
                _cache[6] || (_cache[6] = _createElementVNode("td", { class: "text-center" }, [
                    _createCommentVNode(" 뭘까. ")
                ], -1 /* CACHED */)),
                _createCommentVNode(" 접수번호 "),
                _createElementVNode("td", _hoisted_39, _toDisplayString(_unref(orderItem).orderId), 1 /* TEXT */),
                _createCommentVNode(" 운행거리 "),
                _createElementVNode("td", _hoisted_40, [
                    _createCommentVNode(" { orderItem.payTypeCode }} "),
                    _createTextVNode(" " + _toDisplayString(_unref(orderItem).distanceKilometer) + " " + _toDisplayString(_ctx.$t('common.km')), 1 /* TEXT */)
                ])
            ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1)), [
                [_directive_tr_highlight, cssClassHighlight.value, "border"]
            ]);
        };
    }
});
